import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BarcodeBookState, WebRoutes } from "../../../../../Constants";
import {
  displayDate,
  isDateBetweenDates,
  isDateGreaterThan,
  objectToQueryString,
} from "../../../../../Helpers/utils/utils";
import { hasValue } from "../../../../../Helpers/validations/common";
import { CompleteModal } from "../CompleteModal/CompleteModal";
import "./HeaderStudent.scss";

const HeaderStudent = ({
  barcode,
  dates,
  books,
  handleUpdate,
  handleComplete,
}) => {
  const navigate = useNavigate();
  const [t] = useTranslation();
  const userData = useSelector((state) => state.user.credentials);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [editDisabled, setEditDisabled] = useState(false);
  const [saveChangesDisabled, setSaveChangesDisabled] = useState(false);

  const update = () => {
    setSaveChangesDisabled(true);
    setEditDisabled(true);
    handleUpdate();
    setTimeout(() => {
      setSaveChangesDisabled(false);
      setEditDisabled(false);
    }, 3000);
  };

  const canComplete = () => {
    const initialStatusBooks = books.filter(
      (x) => x.state === BarcodeBookState.Initial
    );
    if (initialStatusBooks.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const renderRightColumn = () => {
    const startDate = new Date(dates.start);
    const endDate = new Date(dates.end);
    const currentDate = new Date();
    let html = [];
    if (isDateBetweenDates(currentDate, startDate, endDate)) {
      if (barcode.isCompleted) {
        html.push(
          <div key={"button-summary"} className="button-wrapper">
            <Button
              className="button-cancel"
              disabled={editDisabled}
              onClick={() => update()}
            >
              {t("Edit")}
            </Button>
            <Button
              className="button"
              onClick={() =>
                navigate(
                  WebRoutes.SummaryBooks +
                    objectToQueryString(
                      { code: barcode.barcodeHash },
                      true
                    )
                )
              }
            >
              {t("SeeSummary")}
            </Button>
          </div>
        );
      } else {
        html.push(
          <div key={"button-complete"} className="button-wrapper">
            <Button
              className="button-cancel"
              disabled={saveChangesDisabled}
              onClick={() => update()}
            >
              {t("SaveChanges")}
            </Button>
            <Button
              className="button"
              disabled={!canComplete()}
              onClick={() => setShowCompleteModal(true)}
            >
              {t("Complete")}
            </Button>
          </div>
        );
      }
      html.push(
        <div key={"completed-text"} className="completed-text">
          {barcode.isCompleted ? t("CompletedText") : t("NotCompletedText")}
        </div>
      );
    } else {
      if (!isDateGreaterThan(startDate, currentDate)) {
        html.push(
          <div key={"button-summary"} className="button-wrapper">
            <Button
              className="button"
              onClick={() =>
                navigate(
                  WebRoutes.SummaryBooks +
                    objectToQueryString(
                      { code: barcode.barcodeHash },
                      true
                    )
                )
              }
            >
              {t("SeeSummary")}
            </Button>
          </div>
        );
      }
      html.push(
        <div key={"time-over"} className="message-wrapper">
          <div className="message">
            {isDateGreaterThan(currentDate, endDate)
              ? t("TimeIsOver")
              : t("YouCantEditYet")}
          </div>
        </div>
      );
    }
    return html;
  };

  return (
    <div className="header-student">
      <div className="left-wrapper">
        <div className="title">
          {t("HomePageTitle")} {userData.firstName},
        </div>
        <div className="date-range">
          {t("Since")}
          <span className="date-square">{displayDate(dates.start)}</span>
          {t("Until")}
          <span className="date-square">{displayDate(dates.end)}</span>
        </div>
        <div className="place">{`${t("Place")}: ${
          hasValue(dates.returnLocation) ? dates.returnLocation : "-"
        }`}</div>
      </div>
      <div className="right-wrapper">{renderRightColumn()}</div>
      {showCompleteModal && (
        <CompleteModal
          books={books}
          show={showCompleteModal}
          onHide={() => setShowCompleteModal(false)}
          updateBooks={() => handleUpdate()}
          completeBooks={() => {
            setShowCompleteModal(false);
            handleComplete();
          }}
        />
      )}
    </div>
  );
};

export default HeaderStudent;
